import { useCallback } from "react";
import { useIntl } from "react-intl";

export default function useServerMessage() {
  const { locale } = useIntl();

  return useCallback(
    (object, key) => {
      let lang = locale.split("-")[0];
      lang = lang.charAt(0).toUpperCase() + lang.slice(1);
      return object ? object[`${key}${lang}`] : undefined;
    },
    [locale]
  );
}
